import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import VueAxios from 'vue-axios';
//import fz from 'fuzzaldrin-plus';
//import { Container, Draggable } from "vue-smooth-dnd";
import Accueil from './components/Accueil.vue';
import VueMq from 'vue-mq';
import('./main.css');

import 'vue2-dropzone/dist/vue2Dropzone.css';
import { url_base } from './variables.js'

Vue.use(VueAxios, axios);
Vue.use(VueRouter);

///////////  ROUTES /////////////

const routes = [
{
  name: "accueil",
  path: url_base,
  component: Accueil
},
{
  name: "vue",
  path: url_base+':vue',
  component: Accueil,
  children: [
    {
      name: "projet",
      path:':projet',
      component: Accueil
    }
  ]
}];


const router = new VueRouter({
  mode: 'history',
  routes: routes
});


Vue.use(VueMq, {
  breakpoints: {
    mobile: 750,
    desktop: Infinity
  }
})
 

///////////  BUS ET STATE COMMUN /////////////

export const state = new Vue({
  data() {
    return {
      fiches: [],
      acteurs: [],
      acteurs_par_id: {},
      mots_clefs: [],
      fonctions: [],
      fonctions_par_id: {},
      projet_actif: false,
      mode: "intro"
      // vue_principale:  {
      //   vue: "tableau"
      // },

      // modal_ajout: {
      //   ouvrir: false,
      //   type: "",
      //   edition: "",
      //   edition_subtype: "",
      //   edition_aa_inventory_number: ""
      // },

      // modal_objet: {
      //   aa_inventory_number: "",
      //   ouvrir: false
      // },

      // recherche: "",
      // objets: {},
      // langue: {
      //   id: 0
      // },
      // affichage_types: {},
      // annees: []
    }
  }
})

///////////  INIT /////////////


Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router
}).$mount('#app')